import jwt from "jsonwebtoken";
async function verifyJwt(token: string): Promise<any> {
  return await new Promise((resolve, reject) => {
    try {
      let decoded = jwt.decode(token);
      resolve(decoded);
    } catch (err) {
      reject(err);
    }
  });
}
const crypt = {
  verifyJwt,
};
export default crypt;
